import React from 'react';
import { Text } from '@react-pdf/renderer';
import { styles } from '../styles';
import PropTypes from 'prop-types';

const propTypes = {
  invoiceContent: PropTypes.object.isRequired,
};

const InvoiceHeader = () => {
  return (
    <Text style={styles.invoiceHeader} fixed>
      ~ Powered By DOCloud ~
    </Text>
  );
};

InvoiceHeader.propTypes = propTypes;

export default InvoiceHeader;
